.container {
	flex: 1;
	display: flex;
	position: relative;
	width: 100%;
	height: 100%;
}

.container:not(.isReady) {
	pointer-events: none;
}

.innerContainer {
	flex-grow: 1;
	height: 100%;
}

.innerContainer:not(.isReady) {
	opacity: 0;
}
